module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0646.dc1238ca.jpg";